import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../store/customRequest/actions";
var TASK_POLL_BASE_INTERVAL_MS = 3000;
var TASK_POLL_MAX_INTERVAL_MS = 15000;
var TASK_POLL_BACKOFF_FACTOR = 1.5;
export var TASK_POLL_TERMINAL_STATUSES = [
    "COMPLETED",
    "FAILED",
    "CANCELLED",
];
var buildTaskPollingRequestKey = function (taskId) {
    return "taskPolling-".concat(taskId);
};
var buildTaskPollingPath = function (taskId) {
    return "/asg/Api/V1/Tasks/".concat(taskId);
};
export var useTaskPolling = function (taskId) {
    var _a, _b, _c;
    var dispatch = useDispatch();
    var timerRef = useRef(null);
    var nextIntervalRef = useRef(TASK_POLL_BASE_INTERVAL_MS);
    var requestKey = taskId ? buildTaskPollingRequestKey(taskId) : null;
    var _d = useSelector(function (state) {
        var _a, _b, _c, _d, _e, _f;
        return ({
            task: requestKey
                ? (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[requestKey]
                : undefined,
            error: requestKey
                ? (_d = (_c = state.CustomRequest) === null || _c === void 0 ? void 0 : _c.errorCustomRequest) === null || _d === void 0 ? void 0 : _d[requestKey]
                : undefined,
            loading: requestKey
                ? Boolean((_f = (_e = state.CustomRequest) === null || _e === void 0 ? void 0 : _e.loadingCustomRequest) === null || _f === void 0 ? void 0 : _f[requestKey])
                : false,
        });
    }), task = _d.task, error = _d.error, loading = _d.loading;
    var status = (_a = task === null || task === void 0 ? void 0 : task.status) !== null && _a !== void 0 ? _a : null;
    var isTerminal = status
        ? TASK_POLL_TERMINAL_STATUSES.includes(status)
        : false;
    useEffect(function () {
        nextIntervalRef.current = TASK_POLL_BASE_INTERVAL_MS;
        if (!taskId)
            return undefined;
        var requestKeyForTask = buildTaskPollingRequestKey(taskId);
        dispatch(customRequestApis({
            requestKey: requestKeyForTask,
            method: "GET",
            path: buildTaskPollingPath(taskId),
        }));
        return function () {
            if (timerRef.current)
                clearTimeout(timerRef.current);
            dispatch(clearCustomRequest(requestKeyForTask));
        };
    }, [taskId]);
    useEffect(function () {
        if (!taskId || loading || isTerminal)
            return undefined;
        if (!task && !error)
            return undefined;
        var requestKeyForTask = buildTaskPollingRequestKey(taskId);
        timerRef.current = setTimeout(function () {
            dispatch(customRequestApis({
                requestKey: requestKeyForTask,
                method: "GET",
                path: buildTaskPollingPath(taskId),
            }));
            nextIntervalRef.current = Math.min(nextIntervalRef.current * TASK_POLL_BACKOFF_FACTOR, TASK_POLL_MAX_INTERVAL_MS);
        }, nextIntervalRef.current);
        return function () {
            if (timerRef.current)
                clearTimeout(timerRef.current);
        };
    }, [task, error, loading, taskId, isTerminal]);
    return {
        task: task,
        status: status,
        progress: (_b = task === null || task === void 0 ? void 0 : task.progress) !== null && _b !== void 0 ? _b : 0,
        error: error,
        result: (_c = task === null || task === void 0 ? void 0 : task.result) !== null && _c !== void 0 ? _c : null,
        loading: loading,
        isTerminal: isTerminal,
    };
};
